<template>
    <div>
        <inertia-head :title="title"/>

        <div
            class="flex h-screen dark:bg-gray-900"
            :class="{ 'overflow-hidden': isSideMenuOpen}"
        >
            <template v-if="!surveyLayout">
                <!-- Desktop sidebar -->
                <aside class="z-20 pt-16 hidden w-64 shadow-sm overflow-y-auto bg-white dark:bg-gray-800 md:block flex-shrink-0">
                    <sidebar></sidebar>
                </aside>
                <!-- Mobile sidebar -->
                <!-- Backdrop -->
                <transition enter-active-class="transition ease-in-out duration-150"
                            enter-from-class="opacity-0"
                            enter-to-class="opacity-100"
                            leave-active-class="transition ease-in-out duration-150"
                            leave-from-class="opacity-100"
                            leave-to-class="opacity-0"
                >
                    <div
                        v-show="isSideMenuOpen"
                        class="fixed inset-0 z-10 flex items-end bg-black bg-opacity-50 sm:items-center sm:justify-center"
                    ></div>
                </transition>
                <transition ref="mobileSidebar"
                            enter-active-class="transition ease-in-out duration-150"
                            enter-from-class="opacity-0 transform -translate-x-20"
                            enter-to-class="opacity-100"
                            leave-active-class="transition ease-in-out duration-150"
                            leave-from-class="opacity-100"
                            leave-to-class="opacity-0 transform -translate-x-20"
                >
                    <aside
                        class="transform fixed inset-y-0 z-20 flex-shrink-0 w-64 mt-16 overflow-y-auto bg-white dark:bg-gray-800 md:hidden"
                        v-show="isSideMenuOpen"
                        @keydown.esc="closeSideMenu"
                    >
                        <sidebar></sidebar>
                    </aside>
                </transition>
            </template>

            <div class="flex flex-col flex-1 w-full">
                <top-bar v-if="!surveyLayout"
                         :is-side-menu-open="isSideMenuOpen"
                         @side-menu-toggle="isSideMenuOpen=$event"
                         />
                <survey-top-bar v-else :survey-logo="$page.props.surveyModel.logo_url"/>
                <main class="h-full pb-16 overflow-y-auto flex-1 mt-16" id="mainContent">
                    <div class="container px-6 mx-auto grid">
                        <h2 v-if="!surveyLayout"
                            class="mt-6 mb-11 text-2xl font-semibold dark:text-gray-200">
                            <slot name="header"></slot>
                        </h2>
                        <slot></slot>
                    </div>
                </main>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue';
import JetApplicationMark from '@/Jetstream/ApplicationMark.vue';
import Sidebar from "@/Jetstream/Sidebar";
import TopBar from "@/Jetstream/TopBar";
import {onClickOutside} from '@vueuse/core';
import { Inertia } from "@inertiajs/inertia";
import SurveyTopBar from "@/Components/Survey/SurveyTopBar";

export default defineComponent({
    props: {
        title: String,
        surveyLayout: {
            type: Boolean,
            default: false,
        }
    },

    components: {
        SurveyTopBar,
        JetApplicationMark,
        Sidebar,
        TopBar,
    },
    data() {
        return {
            isSideMenuOpen: false,
            showingNavigationDropdown: false,
            InertiaSuccessEventListener: null,
        }
    },
    mounted() {
        // ClickOutside listener for closing menus
        onClickOutside(this.$refs.mobileSidebar, event => {
            if (!document.getElementById('toggleMenuButton').contains(event.target)) {
                this.closeSideMenu();
            }
        });

        //Add event listener for successful page load
        this.InertiaSuccessEventListener = Inertia.on('finish', this.displayFlashMessages);
        window.addEventListener('load', this.displayFlashMessages);
    },
    unmounted() {
        // This removes the event listener
        this.InertiaSuccessEventListener();
        window.removeEventListener('load', this.displayFlashMessages);
    },
    methods: {
        closeSideMenu() {
            this.isSideMenuOpen = false
        },
        displayFlashMessages() {
            // console.log(`Successfully made a visit to ${event.detail.page.url}`)
            // Flash messages get displayed as toasts
            Object.entries(this.$page.props.flash).forEach(([toastType, toastMessage]) => {
                //console.log(toastMessage)
                let options = {};
                if (['warning', 'error'].includes(toastType)) {
                    options = {
                        timeout: 0,
                    }
                }
                options = {...options, type: toastType}
                if (toastMessage && toastMessage.length) {
                    this.$toast(toastMessage, options);
                }
            });
        }
    }
})
</script>
